import { useState } from "react";
import Layout from "../../../Containers/Layout";
import styles from "./EAFSGAreaForm.module.scss";
import { Form, Col, Row, Input } from "antd";
import CustomForm from "../../../CustomComponents/CustomForm";
import { theme } from "../../../theme";
import { Redirect, useParams } from "react-router-dom";
import {
  NOTIFICATION_TYPES,
  openNotification,
} from "../../Notifications/NotificationsUtils";
import ConfirmationModal from "../../../Containers/ConfirmationModal";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { addEAFSGArea, getEAFSGArea, updateEAFSGArea } from "../../../Requests/eafsg-area-requests";

const EAFSGAreaForm = () => {
  const { t } = useTranslation();

  const openGetErrorNotification = (_error: any) => {
    openNotification(
      'Eroare',
      'Datele nu au putut fi aduse din server!',
      NOTIFICATION_TYPES.ERROR
    );
  };

  const [redirect, setRedirect] = useState(false);

  const [form] = Form.useForm<{
    name: string | null,
    description: string | null,
  }>();

  const { eafsgAreaId } = useParams<{ eafsgAreaId: string }>();

  useQuery(["getEAFSGArea", eafsgAreaId], () => getEAFSGArea(eafsgAreaId), {
    enabled: !!eafsgAreaId,
    onError: openGetErrorNotification,
    onSuccess: (data) => {
      if (data) {
        form.setFieldsValue({
          name: data.name,
          description: data.description,
        });
      }
    },
    refetchOnWindowFocus: false
  });

  const openSaveErrorNotification = (error: any) => {
    const serverMessage =
      (typeof error?.body === "string" && error.body) ||
      (typeof error?.body?.message === "string" && error.body.message) ||
      (typeof error?.response?.data === "string" && error.response.data) ||
      (typeof error?.response?.data?.message === "string" && error.response.data.message);

    if (serverMessage) {
      openNotification('Eroare!', serverMessage, NOTIFICATION_TYPES.ERROR);
      return;
    }

    if (error.status === 400 || error.status === 409) {
      openNotification('Eroare!', 'Datele completate nu sunt valide!', NOTIFICATION_TYPES.ERROR);
    } else {
      openNotification('Eroare!', 'Propunerea nu a putut fi salvată!', NOTIFICATION_TYPES.ERROR);
    }
  };

  const handleCancel = () => {
    setRedirect(true);
  };

  const openSuccessNotificationAndRedirect = () => {
    setRedirect(true);
    openNotification('Succes!', 'Salvarea s-a efectuat cu succes!', NOTIFICATION_TYPES.SUCCESS, 6);
  }

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const obj = {
        name: values.name!,
        description: values.description ?? '',
      };

      (eafsgAreaId ? updateEAFSGArea(eafsgAreaId, obj) : addEAFSGArea(obj))
        .then(openSuccessNotificationAndRedirect)
        .catch(openSaveErrorNotification);
    } catch {
      openNotification('Eroare!', 'Datele introduse nu sunt valide!', NOTIFICATION_TYPES.ERROR);
    }
  };

  if (redirect) {
    return <Redirect to='/arii-eafsg' />;
  }

  return (
    <Layout>
      <div className={`container ${styles.container}`}>
        <CustomForm form={form} layout={theme.layout} boxshadow={"none"}>
          <div className={styles.firstLine}>
            <Row gutter={8}>
              <Col span={24}>
                <Form.Item
                  name='name'
                  label='Denumirea ariei EAFSG:'
                  rules={[{ required: true, message: 'Denumirea ariei EAFSG este obligatorie!', whitespace: true }]}
                >
                  <Input placeholder='Completează denumirea ariei EAFSG' />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name='description' label='Descriere:'>
                  <Input.TextArea placeholder='Completează descrierea ariei EAFSG' rows={9} />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div className={styles.secondLine}>
            <div className={styles.firstColumn}>
              <ConfirmationModal
                nameButton={t('internships.addInternshipForm.cancel')}
                modalText={t('internships.cancelMessage')}
                titleButton={''}
                handleFunction={handleCancel}
                iconButton={null}
                shapeButton={''}
                typeButton={''}
                disabledProp={false}
                styleProp={{ background: theme.green, color: theme.white, marginRight: '10%', marginTop: '0%', boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px' }}
              />
              <ConfirmationModal
                nameButton={eafsgAreaId ? t('internships.addInternshipForm.updateButton') : t('internships.addInternshipForm.saveButton')}
                modalText={t('internships.saveMessage')}
                titleButton={''}
                handleFunction={handleSave}
                iconButton={null}
                shapeButton={''}
                typeButton={''}
                disabledProp={false}
                styleProp={{ background: theme.secondColor, color: theme.white, marginRight: '10%', marginTop: '0%', boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px' }}
              />
            </div>
          </div>
        </CustomForm>
      </div>
    </Layout>
  );
};

export default EAFSGAreaForm;
